import { createContext } from 'react'

const SuggestedChangeContext = createContext()

export default SuggestedChangeContext
